module.exports = __webpack_public_path__ + "static/media/registration-review-blob.6f0edbc1.svg";